// Palette partagée par tous les écrans MFA (Activation, Vérification, Config, Admin, Challenge).
// Centraliser ces valeurs évite qu'un nouvel écran reparte sur une couleur différente
// (c'est ce qui était arrivé à MfaVerifyPage.tsx, resté en bleu #1976d2).
export const mfaTheme = {
  primary: '#0f9b7e',       // icônes actives, accents
  primaryDark: '#0a6a55',   // titres, texte fort
  primaryHover: '#0e8a6f',  // hover des boutons pleins
  primaryBg: '#f0f9f6',     // fonds de card "info"
  primaryBorder: '#dbeae3', // bordures de card "info"
  pageBg: '#f5f5f5',        // fond de page plein écran
  textMuted: '#5d6d68',
  textMuted2: '#4e5d59',
  inactive: '#999999',
} as const;